/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon32Regular = forwardRef('MediaUiAPauseIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M13 6a1 1 0 1 0-2 0v20a1 1 0 1 0 2 0V6Z" }),
        React.createElement("path", { d: "M21 6a1 1 0 1 0-2 0v20a1 1 0 1 0 2 0V6Z" })));
});
